const apiUrl = process.env.REACT_APP_DJANGO_API_URL || "http://localhost:8000";
const chatUrl =
  process.env.REACT_APP_DJANGO_API_URL_WS || "ws://localhost:8000";
const ServiceWorkerURL = process.env.PUBLIC_URL || "http://localhost:3000";

if (!apiUrl) {
  throw new Error("REACT_APP_DJANGO_API_URL is not defined");
}

const config = {
  apiUrl,
  chatUrl,
  ServiceWorkerURL,
} as const;

export default config;
